import { render, staticRenderFns } from "./Include.vue?vue&type=template&id=8036591c&scoped=true"
import script from "./Include.vue?vue&type=script&lang=js"
export * from "./Include.vue?vue&type=script&lang=js"
import style0 from "./Include.vue?vue&type=style&index=0&id=8036591c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036591c",
  null
  
)

export default component.exports